import debug from 'debug'

/*
 * For show CXF-AD-BANNER debug messages just run in a browser console
 * localStorage.debug = 'CXF-AD-BANNER:*'
 */
const logger = debug('CXF-AD-BANNER:')

export default logger
